// extracted by mini-css-extract-plugin
export default {"switcher":"LanguageSwitcher_switcher__O+vHv","button":"LanguageSwitcher_button__YyuKF","active":"LanguageSwitcher_active__iSpgn"};